/* tslint:disable */
/* eslint-disable */
/**
 * Integrations Service
 * Provides an API to integrate with various 3rd party integrations
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ParagonInstallRequest
 */
export interface ParagonInstallRequest {
    /**
     * 
     * @type {string}
     * @memberof ParagonInstallRequest
     */
    providerType: ParagonInstallRequestProviderTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ParagonInstallRequest
     */
    externalProviderId: string;
    /**
     * 
     * @type {string}
     * @memberof ParagonInstallRequest
     */
    organisationUrl?: string;
}


/**
 * @export
 */
export const ParagonInstallRequestProviderTypeEnum = {
    Dynamics: 'DYNAMICS',
    Hubspot: 'HUBSPOT',
    Salesforce: 'SALESFORCE',
    Zoho: 'ZOHO'
} as const;
export type ParagonInstallRequestProviderTypeEnum = typeof ParagonInstallRequestProviderTypeEnum[keyof typeof ParagonInstallRequestProviderTypeEnum];


/**
 * Check if a given object implements the ParagonInstallRequest interface.
 */
export function instanceOfParagonInstallRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "providerType" in value;
    isInstance = isInstance && "externalProviderId" in value;

    return isInstance;
}

export function ParagonInstallRequestFromJSON(json: any): ParagonInstallRequest {
    return ParagonInstallRequestFromJSONTyped(json, false);
}

export function ParagonInstallRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParagonInstallRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'providerType': json['providerType'],
        'externalProviderId': json['externalProviderId'],
        'organisationUrl': !exists(json, 'organisationUrl') ? undefined : json['organisationUrl'],
    };
}

export function ParagonInstallRequestToJSON(value?: ParagonInstallRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'providerType': value.providerType,
        'externalProviderId': value.externalProviderId,
        'organisationUrl': value.organisationUrl,
    };
}

